
















































































































































































































import SwapErrorBox from '@/components/SwapErrorBox.vue'
import SwapPoweredBy from '@/components/SwapPoweredBy.vue'
import SwapSettingsCard from '@/components/SwapSettingsCard.vue'
import SwapSelectToken from '@/components/SwapSelectToken.vue'
import SwapTransactionDetailsCard from '@/components/SwapTransactionDetailsCard.vue'
import SwapTokenInfo from '@/components/SwapTokenInfo.vue'
import {Component, Prop} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {TokensTableItem} from '@/model/resource/TokensTableItem'
import {TokensTableItemsCollection} from '@/model/collection/TokensTableItemsCollection'
import {BalanceResponse} from '@/helpers/ShrikeHelper'
import SwapInputAmount from '@/components/SwapInputAmount.vue'
import SwapLockedAmount from '@/components/SwapLockedAmount.vue'

@Component({
  components: {
    SwapInputAmount,
    SwapTransactionDetailsCard,
    SwapSettingsCard,
    SwapPoweredBy,
    SwapErrorBox,
    SwapSelectToken,
    SwapTokenInfo,
    SwapLockedAmount,
  },
})
export default class SwapFormStep extends MixinScreenSize {
  @Prop({type: Array, required: true}) accountBalance!: BalanceResponse[]
  @Prop({type: Number, required: true})
  allowedSlippageInPercentage!: number
  @Prop({type: String, required: true}) amountToReceive!: string
  @Prop({type: String, required: true}) amountToReceiveInDollar!: string
  @Prop({type: String, required: true}) amountToUse!: string
  @Prop({type: String, required: true}) amountToUseInDollar!: string
  @Prop({type: Boolean, required: true}) isAmountToReceiveValid!: boolean
  @Prop({type: Boolean, required: true}) isAmountToUseValid!: boolean
  @Prop({type: Boolean, required: true}) isSlippageHigh!: boolean
  @Prop({type: Boolean, required: true}) isMyWalletPage!: boolean
  @Prop({type: String, required: true})
  minimumReceived!: string
  @Prop({type: String, required: true}) priceInverse!: string
  @Prop({required: true}) tokenToReceive!: TokensTableItem | null
  @Prop({required: true}) tokenToUse!: TokensTableItem | null
  @Prop({type: TokensTableItemsCollection, required: true})
  tokensTableItemsCollection!: TokensTableItemsCollection
  @Prop({type: String, required: true}) maxAmountAvailableToUse!: string
  @Prop({type: Array}) tokenToUseOptions!: TokensTableItem[]
  @Prop({type: Array}) tokenToReceiveOptions!: TokensTableItem[]

  get lockedAmount() {
    if (this.isMyWalletPage) {
      return this.amountToReceive
    }

    return this.amountToUse
  }

  get lockedAmountInDollar() {
    if (this.isMyWalletPage) {
      return this.amountToReceiveInDollar
    }

    return this.amountToUseInDollar
  }

  get tokenSelectTitle() {
    if (this.isMyWalletPage) {
      return this.$translate('components.SwapFormStep.chooseTokenToReceive')
    }

    return this.$translate('components.SwapFormStep.chooseTokenToUse')
  }

  get tokenSelected() {
    if (this.isMyWalletPage) {
      return this.tokenToReceive
    }

    return this.tokenToUse
  }

  get tokenSelectOptions() {
    if (this.isMyWalletPage) {
      return this.tokenToReceiveOptions
    }

    return this.tokenToUseOptions
  }

  get primaryTokenTitle() {
    if (this.isMyWalletPage) {
      return this.$translate('components.SwapFormStep.youWillUse')
    }

    return this.$translate('components.SwapFormStep.youWillReceive')
  }

  get primaryToken() {
    if (this.isMyWalletPage) {
      return this.tokenToUse
    }

    return this.tokenToReceive
  }

  get primaryAmountInDollar() {
    if (this.isMyWalletPage) {
      return this.amountToUseInDollar
    }

    return this.amountToReceiveInDollar
  }

  get primaryAmount() {
    if (this.isMyWalletPage) {
      return this.amountToUse
    }

    return this.amountToReceive
  }

  get isSwapOpened() {
    if (this.isMyWalletPage && this.tokenToReceive) {
      return true
    }

    if (!this.isMyWalletPage && this.tokenToUse) {
      return true
    }

    return false
  }

  get isProceedDisabled() {
    const amountToUseNumeric =
      this.amountToUse && !isNaN(parseFloat(this.amountToUse))
        ? parseFloat(this.amountToUse)
        : 0

    const amountToReceiveNumeric =
      this.amountToReceive && !isNaN(parseFloat(this.amountToReceive))
        ? parseFloat(this.amountToReceive)
        : 0

    const isAmountToUseInvalid =
      this.amountToUse.trim() === '' || amountToUseNumeric === 0

    const isAmountToReceiveInvalid =
      this.amountToReceive.trim() === '' || amountToReceiveNumeric === 0

    return (
      this.isInputRequired ||
      isAmountToUseInvalid ||
      isAmountToReceiveInvalid ||
      !this.isTokenToUseSelected ||
      !this.isAmountToReceiveValid ||
      !this.isAmountToUseValid ||
      this.isMaxValueExceeded
    )
  }

  get isTokenToUseSelected() {
    return this.tokenToUse !== null
  }

  get isInputRequired() {
    return this.accountBalance.length <= 0 || this.tokenToUseOptions.length <= 0
  }

  get isMaxValueExceeded() {
    return (
      parseFloat(this.amountToUse) > parseFloat(this.maxAmountAvailableToUse)
    )
  }

  mounted() {
    const element = document.querySelector(
      '.swap-form-step__content'
    ) as HTMLElement

    this.addScrollShadow(element)
    this.addScroll(element)

    element.addEventListener('scroll', event => {
      this.addScrollShadow(event.target as HTMLElement)
    })

    window.addEventListener('resize', () => {
      this.addScroll(element)
      this.addScrollShadow(element)
    })
  }

  updated() {
    const element = document.querySelector(
      '.swap-form-step__content'
    ) as HTMLElement

    this.addScrollShadow(element)
    this.addScroll(element)
  }

  addScrollShadow(target: HTMLElement) {
    if (this.isMobile) return

    const {scrollTop} = target
    const headerElement = document.querySelector('.swap-form-step__header')
    const footerElement = document.querySelector('.swap-form-step__footer')

    if (scrollTop > 0) {
      headerElement?.classList.add('shadow-bottom-1/4')
    } else {
      headerElement?.classList.remove('shadow-bottom-1/4')
    }

    const maxScrollTop = target.scrollHeight - target.clientHeight
    if (scrollTop < maxScrollTop) {
      footerElement?.classList.add('shadow-top-1/4')
    } else {
      footerElement?.classList.remove('shadow-top-1/4')
    }
  }

  addScroll(target: HTMLElement) {
    if (target.scrollHeight > target.clientHeight) {
      target.classList.add('overflow-y-scroll')
    } else {
      target.classList.remove('overflow-y-scroll')
    }
  }

  handleUpdateAllowedSlippageInPercentage(val: number): void {
    this.$emit('update:allowedSlippageInPercentage', val)
  }

  handleAmountToUseInput(val: string): void {
    this.$emit('amountToUseInput', val)
  }

  handleTokenSelected(val: TokensTableItem): void {
    this.$emit('tokenSelected', val)
  }

  handleMaxClick(): void {
    this.$emit('maxClick')
  }

  handleProceedClick(): void {
    this.$emit('proceedClick')
  }
}
